import { getHublVariable } from './hubl';
function hasNonHttpRequestScheme(url) {
  return url.indexOf('mailto:') === 0 || url.indexOf('tel:') === 0;
}
function hasHttpRequestScheme(url) {
  return url.indexOf('http:') === 0 || url.indexOf('https:') === 0;
}
export function hasValidUrlScheme(url) {
  return hasHttpRequestScheme(url) || hasNonHttpRequestScheme(url);
}
export function isRawUrl(input = '') {
  const trimmedInput = input.trim().toLocaleLowerCase();
  return hasValidUrlScheme(trimmedInput) || trimmedInput.indexOf('//') === 0 || trimmedInput.indexOf('#') === 0 || getHublVariable(input) !== null;
}